var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-wrapper container-xxl p-0" }, [
    _c("div", { staticClass: "content-header row" }),
    _c(
      "div",
      { staticClass: "content-body" },
      [
        _c("div", { staticClass: "d-flex justify-content-center" }),
        _c(
          "b-row",
          {},
          _vm._l(_vm.sortedCategories, function (category, categoryIndex) {
            return _c(
              "b-col",
              { key: categoryIndex, attrs: { xl: "4", lg: "6", md: "6" } },
              [
                _c(
                  "b-card",
                  { staticClass: "text-center" },
                  [
                    _c("b-card-title", { staticClass: "text-center" }, [
                      _vm._v(" " + _vm._s(category.title) + " "),
                    ]),
                    _c(
                      "b-row",
                      [
                        category.export
                          ? _c(
                              "b-col",
                              { attrs: { xl: "12" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "w-100",
                                    attrs: { variant: "secondary", size: "sm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadFile(
                                          category.downloadLink,
                                          category.title
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "EyeIcon" },
                                    }),
                                    _vm._v(" Export Data "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        category.download
                          ? _c(
                              "b-col",
                              { attrs: { xl: "12" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "w-100 mt-1",
                                    attrs: { variant: "info", size: "sm" },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "text-white",
                                        attrs: {
                                          href:
                                            "/csv/" +
                                            _vm.csvFiles[category.title],
                                          download: "",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _vm._v(" View Example "),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        category.download
                          ? _c(
                              "b-col",
                              { attrs: { xl: "12" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "w-100 mt-1",
                                    attrs: { variant: "success", size: "sm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.open_file(categoryIndex)
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "UploadCloudIcon" },
                                    }),
                                    _vm._v(" Upload File "),
                                  ],
                                  1
                                ),
                                _c("input", {
                                  ref: "mediaInput",
                                  refInFor: true,
                                  staticClass: "d-none",
                                  attrs: {
                                    id: "input_file_" + categoryIndex,
                                    type: "file",
                                    accept: ".csv",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleMediaUpload(
                                        $event,
                                        categoryIndex
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }